'use client';

import type { MatchedGame } from '@rfqsports/shared';
import { GameRow } from './game-row';

interface Props {
  label: string;
  games: MatchedGame[];
}

export function DaySection({ label, games }: Props): JSX.Element {
  return (
    <section aria-label={label} className="flex flex-col gap-3">
      <h2 className="text-base font-semibold text-text">{label}</h2>
      <ul className="flex flex-col gap-3">
        {games.map((g) => (
          <li key={g.id}>
            <GameRow game={g} />
          </li>
        ))}
      </ul>
    </section>
  );
}
